/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AirlineResult,
  CreditAwareSearchRequest,
  CreditAwareSearchResponse,
  FlightBagSelectionRequest,
  FlightBagsResponse,
  FlightBookingCreateRequest,
  FlightBookingHandoffCreateRequest,
  FlightBookingHandoffRefreshRequest,
  FlightBookingHandoffResponse,
  FlightBookingPaymentComponentRequest,
  FlightBookingPaymentComponentResponse,
  FlightBookingQuoteReconfirmRequest,
  FlightBookingResponse,
  FlightBookingThreeDsResumeRequest,
  FlightCancellationConfirmRequest,
  FlightCancellationQuoteCreateRequest,
  FlightCancellationResponse,
  FlightCheckoutError,
  FlightLookupRequest,
  FlightLookupResult,
  FlightPointsEnrichmentResponse,
  FlightSearchRequest,
  FlightSearchResponse,
  FlightSeatMapsResponse,
  Status,
} from "../models/index";
import {
  AirlineResultFromJSON,
  AirlineResultToJSON,
  CreditAwareSearchRequestFromJSON,
  CreditAwareSearchRequestToJSON,
  CreditAwareSearchResponseFromJSON,
  CreditAwareSearchResponseToJSON,
  FlightBagSelectionRequestFromJSON,
  FlightBagSelectionRequestToJSON,
  FlightBagsResponseFromJSON,
  FlightBagsResponseToJSON,
  FlightBookingCreateRequestFromJSON,
  FlightBookingCreateRequestToJSON,
  FlightBookingHandoffCreateRequestFromJSON,
  FlightBookingHandoffCreateRequestToJSON,
  FlightBookingHandoffRefreshRequestFromJSON,
  FlightBookingHandoffRefreshRequestToJSON,
  FlightBookingHandoffResponseFromJSON,
  FlightBookingHandoffResponseToJSON,
  FlightBookingPaymentComponentRequestFromJSON,
  FlightBookingPaymentComponentRequestToJSON,
  FlightBookingPaymentComponentResponseFromJSON,
  FlightBookingPaymentComponentResponseToJSON,
  FlightBookingQuoteReconfirmRequestFromJSON,
  FlightBookingQuoteReconfirmRequestToJSON,
  FlightBookingResponseFromJSON,
  FlightBookingResponseToJSON,
  FlightBookingThreeDsResumeRequestFromJSON,
  FlightBookingThreeDsResumeRequestToJSON,
  FlightCancellationConfirmRequestFromJSON,
  FlightCancellationConfirmRequestToJSON,
  FlightCancellationQuoteCreateRequestFromJSON,
  FlightCancellationQuoteCreateRequestToJSON,
  FlightCancellationResponseFromJSON,
  FlightCancellationResponseToJSON,
  FlightCheckoutErrorFromJSON,
  FlightCheckoutErrorToJSON,
  FlightLookupRequestFromJSON,
  FlightLookupRequestToJSON,
  FlightLookupResultFromJSON,
  FlightLookupResultToJSON,
  FlightPointsEnrichmentResponseFromJSON,
  FlightPointsEnrichmentResponseToJSON,
  FlightSearchRequestFromJSON,
  FlightSearchRequestToJSON,
  FlightSearchResponseFromJSON,
  FlightSearchResponseToJSON,
  FlightSeatMapsResponseFromJSON,
  FlightSeatMapsResponseToJSON,
  StatusFromJSON,
  StatusToJSON,
} from "../models/index";

export interface FlightBookingBagSelectionRequest {
  handoffId: string;
  quoteId: string;
  flightBagSelectionRequest: FlightBagSelectionRequest;
  test?: boolean;
}

export interface FlightBookingBagsRequest {
  handoffId: string;
  quoteId: string;
  test?: boolean;
}

export interface FlightBookingCancellationConfirmRequest {
  bookingId: string;
  cancellationId: string;
  flightCancellationConfirmRequest: FlightCancellationConfirmRequest;
  test?: boolean;
}

export interface FlightBookingCancellationQuoteCreateRequest {
  bookingId: string;
  flightCancellationQuoteCreateRequest: FlightCancellationQuoteCreateRequest;
  test?: boolean;
}

export interface FlightBookingCancellationQuoteGetRequest {
  bookingId: string;
  cancellationId: string;
  test?: boolean;
}

export interface FlightBookingCancellationQuoteLatestGetRequest {
  bookingId: string;
  test?: boolean;
}

export interface FlightBookingCreateOperationRequest {
  flightBookingCreateRequest: FlightBookingCreateRequest;
  test?: boolean;
}

export interface FlightBookingGetRequest {
  bookingId: string;
  test?: boolean;
}

export interface FlightBookingHandoffCreateOperationRequest {
  flightBookingHandoffCreateRequest: FlightBookingHandoffCreateRequest;
  test?: boolean;
}

export interface FlightBookingHandoffGetRequest {
  handoffId: string;
  test?: boolean;
}

export interface FlightBookingHandoffRefreshOperationRequest {
  handoffId: string;
  flightBookingHandoffRefreshRequest: FlightBookingHandoffRefreshRequest;
  test?: boolean;
}

export interface FlightBookingPaymentComponentOperationRequest {
  handoffId: string;
  test?: boolean;
  flightBookingPaymentComponentRequest?: FlightBookingPaymentComponentRequest;
}

export interface FlightBookingQuoteReconfirmOperationRequest {
  handoffId: string;
  quoteId: string;
  flightBookingQuoteReconfirmRequest: FlightBookingQuoteReconfirmRequest;
  test?: boolean;
}

export interface FlightBookingSeatMapsRequest {
  handoffId: string;
  quoteId: string;
  test?: boolean;
}

export interface FlightBookingThreeDsResumeOperationRequest {
  bookingId: string;
  flightBookingThreeDsResumeRequest: FlightBookingThreeDsResumeRequest;
  test?: boolean;
}

export interface SearchAirlineFareClassesGetRequest {
  airlineIata: string;
}

export interface SearchAirlinesGetRequest {
  q?: string;
}

export interface SearchFlightLookupPostRequest {
  flightLookupRequest: FlightLookupRequest;
}

export interface SearchFlightsCreditAwarePostRequest {
  test?: boolean;
  creditAwareSearchRequest?: CreditAwareSearchRequest;
}

export interface SearchFlightsPostRequest {
  flightSearchRequest: FlightSearchRequest;
  test?: boolean;
}

export interface SearchFlightsSearchIdPointsGetRequest {
  searchId: string;
  departureDate: Date;
  test?: boolean;
  pendingSources?: Array<string>;
}

/**
 *
 */
export class FlightsApi extends runtime.BaseAPI {
  /**
   * Persist exact quote-bound optional bag choices as an unpriced draft. An empty array clears choices. Bag-inclusive pricing and purchase remain unavailable.
   */
  async flightBookingBagSelectionRaw(
    requestParameters: FlightBookingBagSelectionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingHandoffResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingBagSelection().'
      );
    }

    if (requestParameters["quoteId"] == null) {
      throw new runtime.RequiredError(
        "quoteId",
        'Required parameter "quoteId" was null or undefined when calling flightBookingBagSelection().'
      );
    }

    if (requestParameters["flightBagSelectionRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBagSelectionRequest",
        'Required parameter "flightBagSelectionRequest" was null or undefined when calling flightBookingBagSelection().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/quotes/{quote_id}/bags`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );
    urlPath = urlPath.replace(
      `{${"quote_id"}}`,
      encodeURIComponent(String(requestParameters["quoteId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBagSelectionRequestToJSON(
          requestParameters["flightBagSelectionRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingHandoffResponseFromJSON(jsonValue)
    );
  }

  /**
   * Persist exact quote-bound optional bag choices as an unpriced draft. An empty array clears choices. Bag-inclusive pricing and purchase remain unavailable.
   */
  async flightBookingBagSelection(
    requestParameters: FlightBookingBagSelectionRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingHandoffResponse> {
    const response = await this.flightBookingBagSelectionRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Read optional bag choices for the owner\'s current test quote. Availability does not reserve or purchase baggage. Unsupported providers return unavailable.
   */
  async flightBookingBagsRaw(
    requestParameters: FlightBookingBagsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBagsResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingBags().'
      );
    }

    if (requestParameters["quoteId"] == null) {
      throw new runtime.RequiredError(
        "quoteId",
        'Required parameter "quoteId" was null or undefined when calling flightBookingBags().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/quotes/{quote_id}/bags`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );
    urlPath = urlPath.replace(
      `{${"quote_id"}}`,
      encodeURIComponent(String(requestParameters["quoteId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBagsResponseFromJSON(jsonValue)
    );
  }

  /**
   * Read optional bag choices for the owner\'s current test quote. Availability does not reserve or purchase baggage. Unsupported providers return unavailable.
   */
  async flightBookingBags(
    requestParameters: FlightBookingBagsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBagsResponse> {
    const response = await this.flightBookingBagsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Explicitly confirm the exact live quote once. Cancellation and refund are separate states; an uncertain provider response remains pending for read-only reconciliation.
   */
  async flightBookingCancellationConfirmRaw(
    requestParameters: FlightBookingCancellationConfirmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightCancellationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingCancellationConfirm().'
      );
    }

    if (requestParameters["cancellationId"] == null) {
      throw new runtime.RequiredError(
        "cancellationId",
        'Required parameter "cancellationId" was null or undefined when calling flightBookingCancellationConfirm().'
      );
    }

    if (requestParameters["flightCancellationConfirmRequest"] == null) {
      throw new runtime.RequiredError(
        "flightCancellationConfirmRequest",
        'Required parameter "flightCancellationConfirmRequest" was null or undefined when calling flightBookingCancellationConfirm().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/cancellation-quotes/{cancellation_id}/confirm`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"cancellation_id"}}`,
      encodeURIComponent(String(requestParameters["cancellationId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightCancellationConfirmRequestToJSON(
          requestParameters["flightCancellationConfirmRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightCancellationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Explicitly confirm the exact live quote once. Cancellation and refund are separate states; an uncertain provider response remains pending for read-only reconciliation.
   */
  async flightBookingCancellationConfirm(
    requestParameters: FlightBookingCancellationConfirmRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightCancellationResponse> {
    const response = await this.flightBookingCancellationConfirmRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Request a short-lived, whole-order cancellation quote. A quote never cancels the order. Unsupported or incomplete supplier terms require manual servicing.
   */
  async flightBookingCancellationQuoteCreateRaw(
    requestParameters: FlightBookingCancellationQuoteCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightCancellationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingCancellationQuoteCreate().'
      );
    }

    if (requestParameters["flightCancellationQuoteCreateRequest"] == null) {
      throw new runtime.RequiredError(
        "flightCancellationQuoteCreateRequest",
        'Required parameter "flightCancellationQuoteCreateRequest" was null or undefined when calling flightBookingCancellationQuoteCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/cancellation-quotes`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightCancellationQuoteCreateRequestToJSON(
          requestParameters["flightCancellationQuoteCreateRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightCancellationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Request a short-lived, whole-order cancellation quote. A quote never cancels the order. Unsupported or incomplete supplier terms require manual servicing.
   */
  async flightBookingCancellationQuoteCreate(
    requestParameters: FlightBookingCancellationQuoteCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightCancellationResponse> {
    const response = await this.flightBookingCancellationQuoteCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Read owner-scoped cancellation and refund progress without supplier mutation.
   */
  async flightBookingCancellationQuoteGetRaw(
    requestParameters: FlightBookingCancellationQuoteGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightCancellationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingCancellationQuoteGet().'
      );
    }

    if (requestParameters["cancellationId"] == null) {
      throw new runtime.RequiredError(
        "cancellationId",
        'Required parameter "cancellationId" was null or undefined when calling flightBookingCancellationQuoteGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/cancellation-quotes/{cancellation_id}`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );
    urlPath = urlPath.replace(
      `{${"cancellation_id"}}`,
      encodeURIComponent(String(requestParameters["cancellationId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightCancellationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Read owner-scoped cancellation and refund progress without supplier mutation.
   */
  async flightBookingCancellationQuoteGet(
    requestParameters: FlightBookingCancellationQuoteGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightCancellationResponse> {
    const response = await this.flightBookingCancellationQuoteGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Recover the latest owner-scoped cancellation request and refund progress after a lost response or app restart.
   */
  async flightBookingCancellationQuoteLatestGetRaw(
    requestParameters: FlightBookingCancellationQuoteLatestGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightCancellationResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingCancellationQuoteLatestGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/cancellation-quotes/latest`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightCancellationResponseFromJSON(jsonValue)
    );
  }

  /**
   * Recover the latest owner-scoped cancellation request and refund progress after a lost response or app restart.
   */
  async flightBookingCancellationQuoteLatestGet(
    requestParameters: FlightBookingCancellationQuoteLatestGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightCancellationResponse> {
    const response = await this.flightBookingCancellationQuoteLatestGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Idempotently request booking of an exact confirmed quote. Payment fields accept only opaque tokenized references; raw card or identity-document material is forbidden.
   */
  async flightBookingCreateRaw(
    requestParameters: FlightBookingCreateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingResponse>> {
    if (requestParameters["flightBookingCreateRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBookingCreateRequest",
        'Required parameter "flightBookingCreateRequest" was null or undefined when calling flightBookingCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingCreateRequestToJSON(
          requestParameters["flightBookingCreateRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingResponseFromJSON(jsonValue)
    );
  }

  /**
   * Idempotently request booking of an exact confirmed quote. Payment fields accept only opaque tokenized references; raw card or identity-document material is forbidden.
   */
  async flightBookingCreate(
    requestParameters: FlightBookingCreateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingResponse> {
    const response = await this.flightBookingCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Return the owner-scoped durable booking lifecycle from the primary ledger.
   */
  async flightBookingGetRaw(
    requestParameters: FlightBookingGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingResponseFromJSON(jsonValue)
    );
  }

  /**
   * Return the owner-scoped durable booking lifecycle from the primary ledger.
   */
  async flightBookingGet(
    requestParameters: FlightBookingGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingResponse> {
    const response = await this.flightBookingGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Preserve a selected discovery observation, re-shop read-only flight suppliers, and return an owner-scoped durable handoff outcome. This endpoint does not create an order or perform a payment or supplier mutation.
   */
  async flightBookingHandoffCreateRaw(
    requestParameters: FlightBookingHandoffCreateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingHandoffResponse>> {
    if (requestParameters["flightBookingHandoffCreateRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBookingHandoffCreateRequest",
        'Required parameter "flightBookingHandoffCreateRequest" was null or undefined when calling flightBookingHandoffCreate().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingHandoffCreateRequestToJSON(
          requestParameters["flightBookingHandoffCreateRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingHandoffResponseFromJSON(jsonValue)
    );
  }

  /**
   * Preserve a selected discovery observation, re-shop read-only flight suppliers, and return an owner-scoped durable handoff outcome. This endpoint does not create an order or perform a payment or supplier mutation.
   */
  async flightBookingHandoffCreate(
    requestParameters: FlightBookingHandoffCreateOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingHandoffResponse> {
    const response = await this.flightBookingHandoffCreateRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Return an owner-scoped durable flight handoff by its opaque Gondola UUID.
   */
  async flightBookingHandoffGetRaw(
    requestParameters: FlightBookingHandoffGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingHandoffResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingHandoffGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingHandoffResponseFromJSON(jsonValue)
    );
  }

  /**
   * Return an owner-scoped durable flight handoff by its opaque Gondola UUID.
   */
  async flightBookingHandoffGet(
    requestParameters: FlightBookingHandoffGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingHandoffResponse> {
    const response = await this.flightBookingHandoffGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Refresh the exact current quote through the same read-only supplier.
   */
  async flightBookingHandoffRefreshRaw(
    requestParameters: FlightBookingHandoffRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingHandoffResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingHandoffRefresh().'
      );
    }

    if (requestParameters["flightBookingHandoffRefreshRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBookingHandoffRefreshRequest",
        'Required parameter "flightBookingHandoffRefreshRequest" was null or undefined when calling flightBookingHandoffRefresh().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/refresh`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingHandoffRefreshRequestToJSON(
          requestParameters["flightBookingHandoffRefreshRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingHandoffResponseFromJSON(jsonValue)
    );
  }

  /**
   * Refresh the exact current quote through the same read-only supplier.
   */
  async flightBookingHandoffRefresh(
    requestParameters: FlightBookingHandoffRefreshOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingHandoffResponse> {
    const response = await this.flightBookingHandoffRefreshRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Issue a browser-safe hosted card component key for the caller\'s current Duffel test handoff. Production collection is unavailable.
   */
  async flightBookingPaymentComponentRaw(
    requestParameters: FlightBookingPaymentComponentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingPaymentComponentResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingPaymentComponent().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/payment-component`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingPaymentComponentRequestToJSON(
          requestParameters["flightBookingPaymentComponentRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingPaymentComponentResponseFromJSON(jsonValue)
    );
  }

  /**
   * Issue a browser-safe hosted card component key for the caller\'s current Duffel test handoff. Production collection is unavailable.
   */
  async flightBookingPaymentComponent(
    requestParameters: FlightBookingPaymentComponentOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingPaymentComponentResponse> {
    const response = await this.flightBookingPaymentComponentRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Record server-versioned customer consent for the exact current quote UUID.
   */
  async flightBookingQuoteReconfirmRaw(
    requestParameters: FlightBookingQuoteReconfirmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingHandoffResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingQuoteReconfirm().'
      );
    }

    if (requestParameters["quoteId"] == null) {
      throw new runtime.RequiredError(
        "quoteId",
        'Required parameter "quoteId" was null or undefined when calling flightBookingQuoteReconfirm().'
      );
    }

    if (requestParameters["flightBookingQuoteReconfirmRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBookingQuoteReconfirmRequest",
        'Required parameter "flightBookingQuoteReconfirmRequest" was null or undefined when calling flightBookingQuoteReconfirm().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/quotes/{quote_id}/reconfirm`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );
    urlPath = urlPath.replace(
      `{${"quote_id"}}`,
      encodeURIComponent(String(requestParameters["quoteId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingQuoteReconfirmRequestToJSON(
          requestParameters["flightBookingQuoteReconfirmRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingHandoffResponseFromJSON(jsonValue)
    );
  }

  /**
   * Record server-versioned customer consent for the exact current quote UUID.
   */
  async flightBookingQuoteReconfirm(
    requestParameters: FlightBookingQuoteReconfirmOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingHandoffResponse> {
    const response = await this.flightBookingQuoteReconfirmRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Read current optional seats for the owner\'s exact quote. Availability is not a reservation. Currently admitted Duffel Airways test quotes only; unsupported providers return unavailable.
   */
  async flightBookingSeatMapsRaw(
    requestParameters: FlightBookingSeatMapsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightSeatMapsResponse>> {
    if (requestParameters["handoffId"] == null) {
      throw new runtime.RequiredError(
        "handoffId",
        'Required parameter "handoffId" was null or undefined when calling flightBookingSeatMaps().'
      );
    }

    if (requestParameters["quoteId"] == null) {
      throw new runtime.RequiredError(
        "quoteId",
        'Required parameter "quoteId" was null or undefined when calling flightBookingSeatMaps().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/booking-handoffs/{handoff_id}/quotes/{quote_id}/seats`;
    urlPath = urlPath.replace(
      `{${"handoff_id"}}`,
      encodeURIComponent(String(requestParameters["handoffId"]))
    );
    urlPath = urlPath.replace(
      `{${"quote_id"}}`,
      encodeURIComponent(String(requestParameters["quoteId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightSeatMapsResponseFromJSON(jsonValue)
    );
  }

  /**
   * Read current optional seats for the owner\'s exact quote. Availability is not a reservation. Currently admitted Duffel Airways test quotes only; unsupported providers return unavailable.
   */
  async flightBookingSeatMaps(
    requestParameters: FlightBookingSeatMapsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightSeatMapsResponse> {
    const response = await this.flightBookingSeatMapsRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Resume a pending 3DS action from backend-authoritative provider state.
   */
  async flightBookingThreeDsResumeRaw(
    requestParameters: FlightBookingThreeDsResumeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightBookingResponse>> {
    if (requestParameters["bookingId"] == null) {
      throw new runtime.RequiredError(
        "bookingId",
        'Required parameter "bookingId" was null or undefined when calling flightBookingThreeDsResume().'
      );
    }

    if (requestParameters["flightBookingThreeDsResumeRequest"] == null) {
      throw new runtime.RequiredError(
        "flightBookingThreeDsResumeRequest",
        'Required parameter "flightBookingThreeDsResumeRequest" was null or undefined when calling flightBookingThreeDsResume().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/flights/bookings/{booking_id}/3ds/resume`;
    urlPath = urlPath.replace(
      `{${"booking_id"}}`,
      encodeURIComponent(String(requestParameters["bookingId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightBookingThreeDsResumeRequestToJSON(
          requestParameters["flightBookingThreeDsResumeRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightBookingResponseFromJSON(jsonValue)
    );
  }

  /**
   * Resume a pending 3DS action from backend-authoritative provider state.
   */
  async flightBookingThreeDsResume(
    requestParameters: FlightBookingThreeDsResumeOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightBookingResponse> {
    const response = await this.flightBookingThreeDsResumeRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Returns the available fare class display names for an airline (used for ticket class selection). Returns an empty array for airlines without defined fare classes.
   */
  async searchAirlineFareClassesGetRaw(
    requestParameters: SearchAirlineFareClassesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<string>>> {
    if (requestParameters["airlineIata"] == null) {
      throw new runtime.RequiredError(
        "airlineIata",
        'Required parameter "airlineIata" was null or undefined when calling searchAirlineFareClassesGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["airlineIata"] != null) {
      queryParameters["airline_iata"] = requestParameters["airlineIata"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/airline_fare_classes`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Returns the available fare class display names for an airline (used for ticket class selection). Returns an empty array for airlines without defined fare classes.
   */
  async searchAirlineFareClassesGet(
    requestParameters: SearchAirlineFareClassesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<string>> {
    const response = await this.searchAirlineFareClassesGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Returns a list of airlines matching the given query string (name or IATA code prefix)
   */
  async searchAirlinesGetRaw(
    requestParameters: SearchAirlinesGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<AirlineResult>>> {
    const queryParameters: any = {};

    if (requestParameters["q"] != null) {
      queryParameters["q"] = requestParameters["q"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/airlines`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(AirlineResultFromJSON)
    );
  }

  /**
   * Returns a list of airlines matching the given query string (name or IATA code prefix)
   */
  async searchAirlinesGet(
    requestParameters: SearchAirlinesGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<AirlineResult>> {
    const response = await this.searchAirlinesGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Looks up flight segments by airline, flight number, and departure date
   */
  async searchFlightLookupPostRaw(
    requestParameters: SearchFlightLookupPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Array<FlightLookupResult>>> {
    if (requestParameters["flightLookupRequest"] == null) {
      throw new runtime.RequiredError(
        "flightLookupRequest",
        'Required parameter "flightLookupRequest" was null or undefined when calling searchFlightLookupPost().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/flight_lookup`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightLookupRequestToJSON(
          requestParameters["flightLookupRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(FlightLookupResultFromJSON)
    );
  }

  /**
   * Looks up flight segments by airline, flight number, and departure date
   */
  async searchFlightLookupPost(
    requestParameters: SearchFlightLookupPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Array<FlightLookupResult>> {
    const response = await this.searchFlightLookupPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Search for flights with credit-aware pricing. Returns Travelport fare results annotated with the user\'s applicable flight credits, effective prices, and ranked by credit value.
   */
  async searchFlightsCreditAwarePostRaw(
    requestParameters: SearchFlightsCreditAwarePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<CreditAwareSearchResponse>> {
    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/flights/credit_aware`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: CreditAwareSearchRequestToJSON(
          requestParameters["creditAwareSearchRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CreditAwareSearchResponseFromJSON(jsonValue)
    );
  }

  /**
   * Search for flights with credit-aware pricing. Returns Travelport fare results annotated with the user\'s applicable flight credits, effective prices, and ranked by credit value.
   */
  async searchFlightsCreditAwarePost(
    requestParameters: SearchFlightsCreditAwarePostRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<CreditAwareSearchResponse> {
    const response = await this.searchFlightsCreditAwarePostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Returns a list offers for the given slice
   */
  async searchFlightsPostRaw(
    requestParameters: SearchFlightsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightSearchResponse>> {
    if (requestParameters["flightSearchRequest"] == null) {
      throw new runtime.RequiredError(
        "flightSearchRequest",
        'Required parameter "flightSearchRequest" was null or undefined when calling searchFlightsPost().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/flights`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: FlightSearchRequestToJSON(
          requestParameters["flightSearchRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightSearchResponseFromJSON(jsonValue)
    );
  }

  /**
   * Returns a list offers for the given slice
   */
  async searchFlightsPost(
    requestParameters: SearchFlightsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightSearchResponse> {
    const response = await this.searchFlightsPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Collect award pricing for a flight search that returned `pending_sources`. Polls each pending program, matches the results against the cash offers already recorded for the search, and returns them per program. Blocks until every program reaches a terminal state or the internal deadline passes.
   */
  async searchFlightsSearchIdPointsGetRaw(
    requestParameters: SearchFlightsSearchIdPointsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FlightPointsEnrichmentResponse>> {
    if (requestParameters["searchId"] == null) {
      throw new runtime.RequiredError(
        "searchId",
        'Required parameter "searchId" was null or undefined when calling searchFlightsSearchIdPointsGet().'
      );
    }

    if (requestParameters["departureDate"] == null) {
      throw new runtime.RequiredError(
        "departureDate",
        'Required parameter "departureDate" was null or undefined when calling searchFlightsSearchIdPointsGet().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["test"] != null) {
      queryParameters["test"] = requestParameters["test"];
    }

    if (requestParameters["departureDate"] != null) {
      queryParameters["departure_date"] = (
        requestParameters["departureDate"] as any
      )
        .toISOString()
        .substring(0, 10);
    }

    if (requestParameters["pendingSources"] != null) {
      queryParameters["pending_sources"] = requestParameters["pendingSources"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/search/flights/{search_id}/points`;
    urlPath = urlPath.replace(
      `{${"search_id"}}`,
      encodeURIComponent(String(requestParameters["searchId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FlightPointsEnrichmentResponseFromJSON(jsonValue)
    );
  }

  /**
   * Collect award pricing for a flight search that returned `pending_sources`. Polls each pending program, matches the results against the cash offers already recorded for the search, and returns them per program. Blocks until every program reaches a terminal state or the internal deadline passes.
   */
  async searchFlightsSearchIdPointsGet(
    requestParameters: SearchFlightsSearchIdPointsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FlightPointsEnrichmentResponse> {
    const response = await this.searchFlightsSearchIdPointsGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Returns a status indicating that the service is operational
   */
  async statusGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<Status>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/status`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      StatusFromJSON(jsonValue)
    );
  }

  /**
   * Returns a status indicating that the service is operational
   */
  async statusGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<Status> {
    const response = await this.statusGetRaw(initOverrides);
    return await response.value();
  }
}
